// Generated by Melange

import * as Buhta_components__LoadingDiv from "../atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../html/Text.js";
import * as Buhta_core__Toast from "../../../core/lib/Toast.js";
import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function toast(kind) {
  return Cn.fromList({
              hd: "flex animate-fadeInTop shadow-panel rounded border border-gray-main/16",
              tl: {
                hd: kind === "warning" ? "bg-alert" : (
                    kind === "default" ? "bg-secondary" : (
                        kind === "success" ? "bg-success" : "bg-links"
                      )
                  ),
                tl: /* [] */0
              }
            });
}

const action = "border-l border-white/24 py-2 px-4";

const Styles = {
  toast: toast,
  action: action
};

function make(toast$1) {
  return function (onExpiredOpt) {
    const onExpired = onExpiredOpt !== undefined ? onExpiredOpt : (function (param) {
          
        });
    const onClick = toast$1.onClick;
    const kind = toast$1.kind;
    const id = toast$1.id;
    const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match[1];
    const onClick$1 = function (param) {
      Curry._1(dispatchToasts, {
            TAG: /* Remove */1,
            _0: id
          });
      Curry._1(onClick, undefined);
    };
    React.useEffect((function () {
            const hide = setTimeout((function (param) {
                    Curry._1(dispatchToasts, {
                          TAG: /* Remove */1,
                          _0: id
                        });
                    Curry._1(onExpired, undefined);
                  }), 3000);
            return (function (param) {
                      clearTimeout(hide);
                    });
          }), []);
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          kind === "loading" ? JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {
                                  size: "w-4 h-4",
                                  borderWidth: "border-2",
                                  primaryColor: "border-white",
                                  secondaryColor: "border-t-transparent",
                                  className: "mr-3"
                                }) : null,
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "whitespace-nowrap text-white",
                                children: toast$1.text
                              })
                        ],
                        className: "py-2 px-4 flex"
                      }),
                  kind === "success" || kind === "warning" ? null : (
                      kind === "default" ? JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                    className: "text-white",
                                    children: "Хорошо"
                                  }),
                              className: action,
                              onClick: (function (param) {
                                  onClick$1(undefined);
                                })
                            }) : JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                    className: "text-white",
                                    children: "Отмена"
                                  }),
                              className: action,
                              onClick: (function (param) {
                                  onClick$1(undefined);
                                })
                            })
                    )
                ],
                className: toast(kind)
              });
  };
}

function ToastView(Props) {
  return make(Props.toast)(Props.onExpired);
}

const make$1 = ToastView;

export {
  Styles ,
  make$1 as make,
}
/* Buhta_components__LoadingDiv Not a pure module */
